import React from 'react';
import MlxBlockUI from '../../components/common/MlxBlockUI/MlxBlockUI';
import withSidebar from '../../hoc/withSideBar/withSideBar';
import OrganizationOverview from './components/OrganizationOverview';
import SubscriptionPlanChart from './components/SubscriptionPlanChart';
import RevenueChart from './components/RevenueChart';
import QuickActionsCard from './components/QuickActionsCard';
import RecentActivityCard from './components/RecentActivityCard';
import { organizationData, subscriptionData, revenueData, quickActions, recentActivities } from './mockData';
import 'primereact/resources/primereact.min.css';
import './Dashboard.scss';

function Dashboard() {
    // State for loading, can be used when fetching real data
    const isLoading = false;

    return (
        <div className="page-section">
            <span className="page-header">Dashboard</span>
            <MlxBlockUI blocked={isLoading}>
                <div className="page-content h-100 overflow-auto">
                    <div className="content-body dashboard-content">
                        <div className="row">
                            <div className="col-12">
                                <OrganizationOverview organizations={organizationData} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 mb-4 mb-md-0">
                                <SubscriptionPlanChart data={subscriptionData} />
                            </div>
                            <div className="col-md-4 mb-4 mb-md-0">
                                <RevenueChart
                                    data={revenueData.monthly}
                                    totalRevenue={revenueData.totalRevenue}
                                    yearlyGrowth={revenueData.yearlyGrowth}
                                    avgMonthly={revenueData.avgMonthly}
                                />
                            </div>
                            <div className="col-md-4">
                                <QuickActionsCard actions={quickActions} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <RecentActivityCard activities={recentActivities} />
                            </div>
                        </div>
                    </div>
                </div>
            </MlxBlockUI>
        </div>
    );
}

export default withSidebar(Dashboard);
